export default {
  label: 'Upload',
  description: '',
  tooltip: '',
  customClass: '',
  hidden: false,
  disabled: false,
  storage: 's3',
  dir: '',
  fileTypes: [],
  fileMinSize: '1B',
  fileMaxSize: '500MB',
  multiple: false,
  validate: {
    required: false
  },
  defaultValue: {
    type: 'value',
    value: []
  },
  key: 'file',
  type: 'file',
  input: true,
  isNew: true,
  amsField: ''
};
